<template>
  <div class="p-12">
    <div class="max-w-5xl mx-auto">
      <div class="space-y-16">
        <div class="flex items-center justify-between">
          <h4 class="text-indigo-500">Pipelines</h4>
          <CreateNewPipelineAction
            v-if="$membershipHasPermissionTo('create pipelines')"
            :account-id="accountId"
          />
        </div>

        <BaseAdvancedList searchable :loading="pending" :entities="pipelines" :meta="meta">
          <template #header>
            <ListHeader />
          </template>

          <template #default="pipelineProps">
            <LineItem :pipeline="pipelineProps.entity" />
          </template>
        </BaseAdvancedList>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import { middleware } from '@/routes/guards';
import ListHeader from '@/components/AccountPipelines/ListHeader.vue';
import LineItem from '@/components/AccountPipelines/ListItem.vue';
import components from './components';

export default {
  components: {
    ListHeader,
    LineItem,
    ...components,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    pending: false,
  }),
  computed: {
    ...mapState('ui/accountPipelines', ['meta']),
    ...mapGetters('ui/accountPipelines', ['pipelines']),
  },
  watch: {
    $route: 'fetchData',
  },
  beforeRouteEnter: middleware('account-permission:read pipelines'),
  created() {
    this.fetchData();
  },
  destroyed() {
    this.setIds([]);
    this.setMeta(null);
    this.setLinks(null);
  },
  methods: {
    ...mapActions('ui/accountPipelines', {
      loadPipelines: 'load',
    }),
    ...mapMutations('ui/accountPipelines', ['setIds', 'setMeta', 'setLinks']),
    async fetchData() {
      const { accountId } = this;
      const { query: params } = this.$route;
      this.pending = true;
      try {
        await this.loadPipelines({
          accountId,
          params: {
            ...params,
            include: 'contact_requests_count',
          },
        });
      } catch (error) {
        //
      }
      this.pending = false;
    },
  },
};
</script>
